import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./config/loadAppStyles";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./ScrollToTop";
import ErrorBoundary from "./ErrorBoundary";
import { LOGIN_BANNER_URL } from "./config/staticAssets";

const initThemeFromStorage = () => {
  const isDark = localStorage.getItem("isDark") === "true";
  const theme = isDark ? "dark" : "light";
  document.documentElement.setAttribute("data-theme", theme);
  document.documentElement.setAttribute("data-bs-theme", theme);
  document.body.classList.toggle("darkMode", isDark);
  document.body.classList.toggle("lightMode", !isDark);
};

initThemeFromStorage();

document.documentElement.style.setProperty(
  "--wlj-login-banner-image",
  `url("${LOGIN_BANNER_URL}")`
);

// Clear service worker cache on hard refresh
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(reg => reg.unregister());
  });
}

// Clear old caches
caches.keys().then(cacheNames => {
  cacheNames.forEach(cacheName => {
    caches.delete(cacheName);
  });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <GoogleOAuthProvider clientId="1083740285274-tvvsachfqqlh5o9818f77dh55kko0nvs.apps.googleusercontent.com">
      <App />
      <Toaster position="top-right" reverseOrder={true} />
    </GoogleOAuthProvider>
  </ErrorBoundary>
);
document.addEventListener("DOMContentLoaded", function () {
  const isDark = localStorage.getItem("isDark");
  if (isDark) {
    document.body.style.backgroundColor = "#1a1a1e";
  } else {
    document.body.style.backgroundColor = "#F2F2F2";
  }
});

reportWebVitals();
